import React from 'react';
import './App.css';
import {Link} from "react-router-dom";

export default function Preview(props: any) {
    return (
        <div className="App-header">
            <div className="MainPanel" style={{textAlign: "center"}}>
                <div style={{fontSize: '30px'}}>
                    Assembly Line
                </div>

                <div style={{marginBottom: '15px'}}>
                    Preview your NFT collection here!
                </div>
                <div style={{marginBottom: '50px'}}>
                    <Link to="/preview/tractors">Tractors</Link>
                    &nbsp;-&nbsp;
                    <Link to="/preview/biznessmen">Biznessmen</Link>
                </div>

            </div>
        </div>
    );
}
